import Vue from 'vue'
import App from './App.vue'
import router from './route'
import utility from "./helpers/utility";

import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(VueChartkick, {adapter: Chart})

import "./assets/css/app.scss"

utility.init();

Vue.config.productionTip = false

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
